import { render, staticRenderFns } from "./VehModels.vue?vue&type=template&id=c1befd52&"
import script from "./VehModels.vue?vue&type=script&lang=js&"
export * from "./VehModels.vue?vue&type=script&lang=js&"
import style0 from "./VehModels.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VehModels.vue"
export default component.exports